import { useEffect, useState } from 'react';
import './RefreshCountdown.css';

const POLL_INTERVAL_SECONDS = 30;

/** Compact, accessible countdown for the next realtime refresh. */
export function RefreshCountdown({ lastUpdate, loading = false }: { lastUpdate: Date | null; loading?: boolean }) {
  const [remaining, setRemaining] = useState(POLL_INTERVAL_SECONDS);

  useEffect(() => {
    setRemaining(POLL_INTERVAL_SECONDS);
    const tick = window.setInterval(() => setRemaining(value => value <= 1 ? POLL_INTERVAL_SECONDS : value - 1), 1000);
    return () => window.clearInterval(tick);
  }, [lastUpdate]);

  const value = loading ? '…' : `${remaining}`;
  return <div className="refresh-countdown" aria-label={`Next refresh in ${loading ? 'a moment' : `${remaining} seconds`}`} title="Realtime data refreshes every 30 seconds">
    <span className="refresh-countdown-value">{value}</span>
    <span className="refresh-countdown-unit">{loading ? 'refreshing' : 'sec'}</span>
  </div>;
}
